module.exports = __webpack_public_path__ + "static/media/contact_college.d3926737.png";